import { Typography } from '@material-ui/core';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import useScrollTextStyles from './styles/scrollText';
import {
    ContentText,
    LegalSubTitleText,
    renderAgreementList,
    renderCommonText,
    renderList,
    renderTitle,
    renderHeadline
} from './helperComponent';

interface Props {}

const ScrollText = ({}: Props) => {
    const { t } = useTranslation('legal');
    const classes = useScrollTextStyles();

    return (
        <div className={classes.main}>
            <div className={classes.fakeHeight}/>
            {renderHeadline(0)}
            {[
                'termsP1',
                { key: 'termsP2', href: 'https://www.apsy.io' },
                'termsP3',
                'termsP4'
            ].map((key) => renderCommonText(key))}
            
            {renderTitle(1)}
            <LegalSubTitleText>{t('termsS2')}</LegalSubTitleText>
            <ContentText>{t('termsP6')}</ContentText>
            <ContentText>{t('termsP7')}</ContentText>
            <ContentText>{t('termsL1head')}</ContentText>
            {renderList('termsL1')}
            {renderTitle(2)}
            <ContentText>{t('termsP9')}</ContentText>
            <ContentText>{t('termsL2head')}</ContentText>
            {renderList('termsL2')}
            {renderTitle(3)}
            <ContentText>{t('termsL3head')}</ContentText>
            {renderList('termsL3')}
            <ContentText>{t('termsL4head')}</ContentText>
            {renderList('termsL4')}
            {renderTitle(4)}
            <ContentText>{t('termsP12')}</ContentText>
            {renderTitle(5)}
            <ContentText>{t('termsP14')}</ContentText>
            <ContentText>{t('termsP15')}</ContentText>
            {renderTitle(6)}
            {renderCommonText({ key: 'termsP17', href: '' })}
            <ContentText>{t('termsP18')}</ContentText>
            {renderTitle(7)}
            <ContentText>{t('termsP20')}</ContentText>
            <ContentText>{t('termsP21')}</ContentText>
            {renderTitle(8)}
            <ContentText>{t('termsP23')}</ContentText>
            {renderTitle(9)}
            {renderCommonText({
                key: 'termsP25',
                href: 'http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm'
            })}
            {renderCommonText({
                key: 'termsP26',
                href: 'https://www.edoeb.admin.ch/edoeb/en/home.html'
            })}
            {renderCommonText('termsP27')}
            <LegalSubTitleText>{t('termsS3')}</LegalSubTitleText>
            <ContentText>{t('termsL5head')}</ContentText>
            {renderList('termsL5')}
            <ContentText>{t('termsP28')}</ContentText>
            {renderCommonText({
                key: 'termsP29',
                href: 'http://www.aboutads.info/choices/'
            })}
            {renderCommonText('termsL6head')}
            {renderList('termsL6')}
            {renderTitle(10, true)}
            <ContentText>{t('termsP30')}</ContentText>
            {renderTitle(11)}
            <ContentText>{t('termsP32')}</ContentText>
            <ContentText>{t('termsP33')}</ContentText>
            {renderTitle(12)}
            <ContentText>{t('termsP35')}</ContentText>
            {renderTitle(13, true)}
            {renderCommonText('termsP36')}
            {/* <ContentText>{t('termsP36')}</ContentText> */}
            <div className={classes.marginLeft}>
                {(t('address', {}, { returnObjects: true }) as any).map((key: string) => (
                    <Trans
                        key={key}
                        i18nKey={key}
                        components={[
                            <Typography variant="body1" className={classes.addressText} />
                        ]}
                    />
                ))}
            </div>
            <br />
            {renderTitle(14, true)}
            {renderCommonText('termsP38')}
            <br />
            <br />
            {renderHeadline(15)}
            {/* <Typography variant="h5" className={classes.title} id={`${TEXT_ID_BASE}${15}`}>
                {t('mutT3')}
            </Typography> */}
            {renderCommonText('mutP1')}
            <ol className={classes.list}>
                {(t(
                    'mutL1',
                    {},
                    { returnObjects: true }
                ) as any).map((key: string, index: number) => renderAgreementList(key, index))}
            </ol>
            <ContentText>{t('mutP2')}</ContentText>
        </div>
    );
};

export default ScrollText;
